import moment from 'moment';

// 폐강(최소 인원 미달로 닫힌 수업) — 직원이 그냥 비공개로 돌린 수업과 구분한다.
// 폐강으로 취소된 예약이 있거나(closedCanceledCount), 자동폐강 마감(closeDate)이 지난 비공개 수업.
export const isClosedByMinCount = event =>
  event?.openYn === 'N' &&
  ((event.closedCanceledCount || 0) > 0 || (!!event.closeDate && moment(event.closeDate).isBefore(moment())));
